<template vue-html>
  <div class="approval-container">
    <el-card class="mobile-approval-row" v-show="!isDetail">
      <h4 style="text-align:center;margin:0 0 15px 0;">审批操作</h4>
      <div>
        <el-button type="danger" size="mini" @click="approvalHandler('N')">不同意</el-button>
        <el-button type="primary" size="mini" @click="approvalHandler('Y')">同意</el-button>
      </div>
    </el-card>
    <cancel-print v-if="type==4" :mode="'mobile'"></cancel-print>
    <exchange-print v-if="type==3" :mode="'mobile'"></exchange-print>
    <el-dialog top="10px" width="100vw" title="审批意见" :visible.sync="vis">
      <el-input type="textarea" v-model="content"></el-input>
      <el-row type="flex" justify="space-around" style="margin-top: 10px">
        <el-button type="danger" @click="vis=false">取消</el-button>
        <el-button type="primary" @click="confirmHandler">确定</el-button>
      </el-row>
    </el-dialog>
  </div>
</template>
<script>
import ExchangeApi from "../../api/foreign/foreign_cancellation/exchange.js";
import CancelApi from "../../api/foreign/foreign_cancellation";
import CancelPrint from "./print_cancellation";
import ExchangePrint from "./print_exchange";
export default {
  name: "documentApproval",
  data() {
    return {
      type: null,
      vis: false,
      content: "",
      agree: null,
      isDetail: true
    };
  },
  components: {
    CancelPrint,
    ExchangePrint
  },
  methods: {
    init() {
      let typeBydb=new URLSearchParams(window.location.search).get('type')||''
      this.type = this.$route.query.type?Number(this.$route.query.type):Number(typeBydb)

      let isDetailBydb=new URLSearchParams(window.location.search).get('isDetail')||''
      this.isDetail = this.$route.query.isDetail?Number(this.$route.query.isDetail):isDetailBydb
    },
    confirmHandler() {
      if (this.type == 3) {
        this.$confirm(`确认是否${this.agree == 'N' ?'不':''}同意审批?`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          ExchangeApi.submitTask({
            renewalId: this.$route.query.id||new URLSearchParams(window.location.search).get('id'),
            opinion: this.content,
            agree: this.agree
          }).then(res => {
            this.$message(res.msg);
            if (res.code == 1) {
              this.$router.replace({
                path: "/mobile-approval-list"
              });
            }
          });
        })
      } else if (this.type == 4) {
          CancelApi.submitTask({
            destroyId: this.$route.query.id||new URLSearchParams(window.location.search).get('id'),
            opinion: this.content,
            agree: this.agree
          }).then(res => {
            this.$message(res.msg);
            if (res.code == 1) {
              this.$router.replace({
                path: "/mobile-approval-list"
              });
            }
          });



      }
    },
    approvalHandler(agree) {
      this.vis = true;
      this.content = "";
      this.agree = agree
    }
  },
  mounted() {
    this.init();
  }
};
</script>
<style lang="scss">
.approval-container {
  background-color: #fff;
  overflow-y: scroll;
  position: relative;
  .mobile-approval-row{
    position: fixed;
    right: 25%;
    bottom: 0;
    background-color: #fff;
    box-shadow: 0 0 4px #ccc;
    .el-card__body {
      padding:10px 20px 10px 20px;
    }
  }
  .approval-row {
    position: fixed;
    right: 0;
    bottom: 0;
    background-color: #fff;
    box-shadow: 0 0 4px #ccc;
    h3 {
      font-size: 16px;
      color: #333;
      text-align: center;
    }
    .el-button {
      font-size: 12px;
    }
  }
  .print-cancellation .el-button {
    display: none;
  }
}
</style>
